import type { Address } from '@dhl/input-address'
import type { CountryCode } from '~/model'

type Arg = {
  firstName: string
  lastName: string
  companyName?: string
  email: string
  address: Address & { countryCode: { key: CountryCode; label: string } }
}

export const toSenderDto = ({ firstName, lastName, companyName, email, address }: Arg) => ({
  email: { address: email },
  address: {
    ...address,
    countryCode: address.countryCode.key,
    isBusiness: companyName !== '',
  },
  name: {
    firstName,
    lastName,
    companyName,
  },
})
